import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../hooks/useAdminAuth';
import { ORAKLE_WEATHER_WEBSITE } from '../../constants/colors';
import { FiKey, FiArrowLeft, FiMail, FiLock } from 'react-icons/fi';
import 'bootstrap/dist/css/bootstrap.css';
import './AdminAuth.css';

const AdminResetPassword = () => {
    const [email, setEmail] = useState('');
    const [localError, setLocalError] = useState(null);
    const [success, setSuccess] = useState(false);
    const { resetPassword, isLoading, error, clearError } = useAdminAuth();
    const navigate = useNavigate();

    useEffect(() => {
        clearError();
    }, [clearError]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLocalError(null);
        setSuccess(false);
        clearError();

        if (!email || !email.includes('@')) {
            setLocalError('Veuillez entrer une adresse email valide');
            return;
        }

        try {
            await resetPassword(email);
            setSuccess(true);
            setTimeout(() => {
                navigate('/admin/login');
            }, 3000);
        } catch (err) {
            setLocalError(err.message || 'Une erreur est survenue');
        }
    };

    return (
        <div className="admin-auth-container">
            <div className="admin-auth-card">
                <div className="admin-auth-header">

                    <div className="icon-header mb-4">
                        <FiKey size={48} className="text-white" strokeWidth={2.5} />
                    </div>
                    <h1>Réinitialiser le mot de passe</h1>
                    <p>Entrez votre adresse email pour recevoir un lien de réinitialisation</p>
                </div>

                <form onSubmit={handleSubmit} className="admin-auth-form">
                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {typeof error === 'string' ? error : JSON.stringify(error)}
                        </div>
                    )}

                    {localError && (
                        <div className="alert alert-danger" role="alert">
                            {typeof localError === 'string' ? localError : JSON.stringify(localError)}
                        </div>
                    )}

                    {success && (
                        <div className="alert alert-success" role="alert">
                            Un email de réinitialisation a été envoyé. Redirection en cours...
                        </div>
                    )}

                    <div className="mb-3">
                        <label htmlFor="email" className="form-label">
                            <FiMail className="me-2" />
                            Adresse email
                        </label>
                        <input
                            type="email"
                            className="form-control"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="admin@example.com"
                            required
                            disabled={isLoading || success}
                        />
                    </div>

                    <button
                        type="submit"
                        className="btn btn-primary w-100 mb-3"
                        disabled={isLoading || success}
                    >
                        {isLoading ? 'Envoi en cours...' : 'Envoyer le lien de réinitialisation'}
                    </button>

                    <button
                        type="button"
                        className="btn btn-link w-100"
                        onClick={() => navigate('/admin/login')}
                        disabled={isLoading}
                    >
                        <FiArrowLeft className="me-2" />
                        Retour à la connexion
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminResetPassword;

